import React from 'react';
import { ArrowLeft, Bell, RefreshCw } from "lucide-react";
import logo from "../assets/logo.png";
import '../CSS/notregister.css'

function NotRegister() {
 return (
    <div className="notokenpage-container">
      {/* ===== Header ===== */}
      <header className="notokenpage-header">
        <div className="notokenpage-header-left">
          <ArrowLeft size={20} className="notokenpage-backicon" />
          <img src={logo} alt="Q-Less Logo" className="notokenpage-logo" />
        
        </div>

        <div className="notokenpage-header-right">
          <Bell size={18} className="notokenpage-icon" />
          <RefreshCw size={18} className="notokenpage-icon" />
        </div>
      </header>

      {/* ===== Welcome Card ===== */}
      <main className="notokenpage-main">
        <div className="notokenpage-welcome-card">
          <h2>Welcome, Thinley Chokdup</h2>
          <p>Your appointment details</p>
        </div>

        <div className="notokenpage-status-box">
          <p>You have no token registered</p>
        </div>
      </main>

      {/* ===== Footer ===== */}
      <footer className="notokenpage-footer">
        © 2025 Q-less. All Rights Reserved.
      </footer>
    </div>
  );
}

export default NotRegister;